/* This file is auto-generated */

import type { ContractPromise } from '@polkadot/api-contract';
import type { KeyringPair } from '@polkadot/keyring/types';
import type { SignerOptions } from '@polkadot/api/submittable/types';
import type { ApiPromise } from '@polkadot/api';
import type { GasLimit, GasLimitAndRequiredValue, Result } from '@arthswap/typechain-types';
import { txSignAndSend } from '@arthswap/typechain-types';
import type * as ArgumentTypes from '../types-arguments/router_contract';
import type BN from 'bn.js';


export default class Methods {
	private __nativeContract : ContractPromise;
	private __keyringPair : KeyringPair;
	private __apiPromise: ApiPromise;

	constructor(
		apiPromise: ApiPromise,
		nativeContract : ContractPromise,
		keyringPair : KeyringPair,
	) {
		this.__apiPromise = apiPromise;
		this.__nativeContract = nativeContract;
		this.__keyringPair = keyringPair;
	}

	/**
	* addLiquidityNative
	*
	* @param { ArgumentTypes.AccountId } token,
	* @param { (string | number | BN) } amountTokenDesired,
	* @param { (string | number | BN) } amountTokenMin,
	* @param { (string | number | BN) } amountNativeMin,
	* @param { ArgumentTypes.AccountId } to,
	* @param { (number | string | BN) } deadline,
	*/
	"addLiquidityNative" (
		token: ArgumentTypes.AccountId,
		amountTokenDesired: (string | number | BN),
		amountTokenMin: (string | number | BN),
		amountNativeMin: (string | number | BN),
		to: ArgumentTypes.AccountId,
		deadline: (number | string | BN),
		__options ? : GasLimitAndRequiredValue,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "router::addLiquidityNative",
			[token, amountTokenDesired, amountTokenMin, amountNativeMin, to, deadline], __options, __signerOptions);
	}

	/**
	* swapExactTokensForNative
	*
	* @param { (string | number | BN) } amountIn,
	* @param { (string | number | BN) } amountOutMin,
	* @param { Array<ArgumentTypes.AccountId> } path,
	* @param { ArgumentTypes.AccountId } to,
	* @param { (number | string | BN) } deadline,
	*/
	"swapExactTokensForNative" (
		amountIn: (string | number | BN),
		amountOutMin: (string | number | BN),
		path: Array<ArgumentTypes.AccountId>,
		to: ArgumentTypes.AccountId,
		deadline: (number | string | BN),
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "router::swapExactTokensForNative",
			[amountIn, amountOutMin, path, to, deadline], __options, __signerOptions);
	}

	/**
	* addLiquidity
	*
	* @param { ArgumentTypes.AccountId } tokenA,
	* @param { ArgumentTypes.AccountId } tokenB,
	* @param { (string | number | BN) } amountADesired,
	* @param { (string | number | BN) } amountBDesired,
	* @param { (string | number | BN) } amountAMin,
	* @param { (string | number | BN) } amountBMin,
	* @param { ArgumentTypes.AccountId } to,
	* @param { (number | string | BN) } deadline,
	*/
	"addLiquidity" (
		tokenA: ArgumentTypes.AccountId,
		tokenB: ArgumentTypes.AccountId,
		amountADesired: (string | number | BN),
		amountBDesired: (string | number | BN),
		amountAMin: (string | number | BN),
		amountBMin: (string | number | BN),
		to: ArgumentTypes.AccountId,
		deadline: (number | string | BN),
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "router::addLiquidity",
			[tokenA, tokenB, amountADesired, amountBDesired, amountAMin, amountBMin, to, deadline], __options, __signerOptions);
	}

	/**
	* factory
	*
	*/
	"factory" (
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "router::factory",
			[], __options, __signerOptions);
	}

	/**
	* getAmountsIn
	*
	* @param { (string | number | BN) } amountOut,
	* @param { Array<ArgumentTypes.AccountId> } path,
	*/
	"getAmountsIn" (
		amountOut: (string | number | BN),
		path: Array<ArgumentTypes.AccountId>,
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "router::getAmountsIn",
			[amountOut, path], __options, __signerOptions);
	}

	/**
	* swapExactTokensForTokens
	*
	* @param { (string | number | BN) } amountIn,
	* @param { (string | number | BN) } amountOutMin,
	* @param { Array<ArgumentTypes.AccountId> } path,
	* @param { ArgumentTypes.AccountId } to,
	* @param { (number | string | BN) } deadline,
	*/
	"swapExactTokensForTokens" (
		amountIn: (string | number | BN),
		amountOutMin: (string | number | BN),
		path: Array<ArgumentTypes.AccountId>,
		to: ArgumentTypes.AccountId,
		deadline: (number | string | BN),
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "router::swapExactTokensForTokens",
			[amountIn, amountOutMin, path, to, deadline], __options, __signerOptions);
	}

	/**
	* wnative
	*
	*/
	"wnative" (
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "router::wnative",
			[], __options, __signerOptions);
	}

	/**
	* swapTokensForExactNative
	*
	* @param { (string | number | BN) } amountOut,
	* @param { (string | number | BN) } amountInMax,
	* @param { Array<ArgumentTypes.AccountId> } path,
	* @param { ArgumentTypes.AccountId } to,
	* @param { (number | string | BN) } deadline,
	*/
	"swapTokensForExactNative" (
		amountOut: (string | number | BN),
		amountInMax: (string | number | BN),
		path: Array<ArgumentTypes.AccountId>,
		to: ArgumentTypes.AccountId,
		deadline: (number | string | BN),
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "router::swapTokensForExactNative",
			[amountOut, amountInMax, path, to, deadline], __options, __signerOptions);
	}

	/**
	* swapNativeForExactTokens
	*
	* @param { (string | number | BN) } amountOut,
	* @param { Array<ArgumentTypes.AccountId> } path,
	* @param { ArgumentTypes.AccountId } to,
	* @param { (number | string | BN) } deadline,
	*/
	"swapNativeForExactTokens" (
		amountOut: (string | number | BN),
		path: Array<ArgumentTypes.AccountId>,
		to: ArgumentTypes.AccountId,
		deadline: (number | string | BN),
		__options ? : GasLimitAndRequiredValue,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "router::swapNativeForExactTokens",
			[amountOut, path, to, deadline], __options, __signerOptions);
	}

	/**
	* getAmountOut
	*
	* @param { (string | number | BN) } amountIn,
	* @param { (string | number | BN) } reserveIn,
	* @param { (string | number | BN) } reserveOut,
	*/
	"getAmountOut" (
		amountIn: (string | number | BN),
		reserveIn: (string | number | BN),
		reserveOut: (string | number | BN),
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "router::getAmountOut",
			[amountIn, reserveIn, reserveOut], __options, __signerOptions);
	}

	/**
	* getAmountsOut
	*
	* @param { (string | number | BN) } amountIn,
	* @param { Array<ArgumentTypes.AccountId> } path,
	*/
	"getAmountsOut" (
		amountIn: (string | number | BN),
		path: Array<ArgumentTypes.AccountId>,
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "router::getAmountsOut",
			[amountIn, path], __options, __signerOptions);
	}

	/**
	* removeLiquidityNative
	*
	* @param { ArgumentTypes.AccountId } token,
	* @param { (string | number | BN) } liquidity,
	* @param { (string | number | BN) } amountTokenMin,
	* @param { (string | number | BN) } amountNativeMin,
	* @param { ArgumentTypes.AccountId } to,
	* @param { (number | string | BN) } deadline,
	*/
	"removeLiquidityNative" (
		token: ArgumentTypes.AccountId,
		liquidity: (string | number | BN),
		amountTokenMin: (string | number | BN),
		amountNativeMin: (string | number | BN),
		to: ArgumentTypes.AccountId,
		deadline: (number | string | BN),
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "router::removeLiquidityNative",
			[token, liquidity, amountTokenMin, amountNativeMin, to, deadline], __options, __signerOptions);
	}

	/**
	* removeLiquidity
	*
	* @param { ArgumentTypes.AccountId } tokenA,
	* @param { ArgumentTypes.AccountId } tokenB,
	* @param { (string | number | BN) } liquidity,
	* @param { (string | number | BN) } amountAMin,
	* @param { (string | number | BN) } amountBMin,
	* @param { ArgumentTypes.AccountId } to,
	* @param { (number | string | BN) } deadline,
	*/
	"removeLiquidity" (
		tokenA: ArgumentTypes.AccountId,
		tokenB: ArgumentTypes.AccountId,
		liquidity: (string | number | BN),
		amountAMin: (string | number | BN),
		amountBMin: (string | number | BN),
		to: ArgumentTypes.AccountId,
		deadline: (number | string | BN),
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "router::removeLiquidity",
			[tokenA, tokenB, liquidity, amountAMin, amountBMin, to, deadline], __options, __signerOptions);
	}

	/**
	* swapExactNativeForTokens
	*
	* @param { (string | number | BN) } amountOutMin,
	* @param { Array<ArgumentTypes.AccountId> } path,
	* @param { ArgumentTypes.AccountId } to,
	* @param { (number | string | BN) } deadline,
	*/
	"swapExactNativeForTokens" (
		amountOutMin: (string | number | BN),
		path: Array<ArgumentTypes.AccountId>,
		to: ArgumentTypes.AccountId,
		deadline: (number | string | BN),
		__options ? : GasLimitAndRequiredValue,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "router::swapExactNativeForTokens",
			[amountOutMin, path, to, deadline], __options, __signerOptions);
	}

	/**
	* getAmountIn
	*
	* @param { (string | number | BN) } amountOut,
	* @param { (string | number | BN) } reserveIn,
	* @param { (string | number | BN) } reserveOut,
	*/
	"getAmountIn" (
		amountOut: (string | number | BN),
		reserveIn: (string | number | BN),
		reserveOut: (string | number | BN),
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "router::getAmountIn",
			[amountOut, reserveIn, reserveOut], __options, __signerOptions);
	}

	/**
	* quote
	*
	* @param { (string | number | BN) } amountA,
	* @param { (string | number | BN) } reserveA,
	* @param { (string | number | BN) } reserveB,
	*/
	"quote" (
		amountA: (string | number | BN),
		reserveA: (string | number | BN),
		reserveB: (string | number | BN),
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "router::quote",
			[amountA, reserveA, reserveB], __options, __signerOptions);
	}

	/**
	* swapTokensForExactTokens
	*
	* @param { (string | number | BN) } amountOut,
	* @param { (string | number | BN) } amountInMax,
	* @param { Array<ArgumentTypes.AccountId> } path,
	* @param { ArgumentTypes.AccountId } to,
	* @param { (number | string | BN) } deadline,
	*/
	"swapTokensForExactTokens" (
		amountOut: (string | number | BN),
		amountInMax: (string | number | BN),
		path: Array<ArgumentTypes.AccountId>,
		to: ArgumentTypes.AccountId,
		deadline: (number | string | BN),
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "router::swapTokensForExactTokens",
			[amountOut, amountInMax, path, to, deadline], __options, __signerOptions);
	}

}
